import { IPurchaseState } from "../entities/PurchaseState";
import { SubscriptionContractSubscriptionStatus } from "../shopifyGraphQL/api";

export function getActiveAndPausedCustomerPurchaseStates<T extends IPurchaseState>(customerPurchaseStates: T[]) {
  return customerPurchaseStates.filter(
    cps =>
      cps.purchaseStateStatus === SubscriptionContractSubscriptionStatus.Active ||
      cps.purchaseStateStatus === SubscriptionContractSubscriptionStatus.Paused
  );
}
